var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['layout-wrapper', { 'has-topbar': _vm.hasTopBar }]},[_vm._t("topBar"),_c('div',{staticClass:"layout-content"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }